import { render, staticRenderFns } from "./ValueChip.vue?vue&type=template&id=5271d593&scoped=true"
import script from "./ValueChip.vue?vue&type=script&lang=js"
export * from "./ValueChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271d593",
  null
  
)

export default component.exports